import React, { Fragment } from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

class InputMemo extends AbstractComponent {    
    constructor(props) {
        super(props);

        this.state = {
            tooltip: false
        }
    }
        
    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }

        return this.props.erro;
    }

    className() {
        return this.props.className !== undefined ? this.props.className : '';
    }    

    classNameInput() {
        return this.props.classNameInput !== undefined ? this.props.classNameInput : '';
    }
    
    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }    

    onChange(input) {        
        if (this.props.onChange !== undefined) {
          this.props.onChange(input);
        }
    }    

    onKeyPress(input) {        
        if (this.props.onKeyPress !== undefined) {
          this.props.onKeyPress(input);
        }
    }   

    onBlur(input) {        
        if (this.props.onBlur !== undefined) {
          this.props.onBlur(input);
        }
    }
    
    componentDidMount() {        
        if(!this.props.defaultFoco)
            return ;
        
        this.foco(this.props.nome);
    }

    show() {
        if(!this.props.visible)
            return ;

        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg}
                style={this.props.style}
            >
                <div className={this.className() + ' ' + this.classErro()} >
                    <label style={{float: 'left'}} htmlFor={this.props.nome}>
                        {this.props.children}

                        {
                            this.props.tooltip !== '' &&                                                                                
                            <button 
                                type="button" 
                                className={"btn btn-secondary my-tooltip " + (this.state.tooltip ? 'active' : '')}
                                style={{
                                    
                                }}                                
                                onClick={() => this.setState({tooltip: !this.state.tooltip})}
                                onBlur={() => this.setState({tooltip: false})} >
                                <i className="fa fa-question-circle" aria-hidden="true"></i>

                                <span className="my-tooltiptext">
                                    {this.props.tooltip}
                                </span>
                            </button>                            
                        }
                    </label>

                    <textarea 
                        autoComplete="off"                           
                        type={this.props.type} 
                        ref={this.props.ref}
                        rows={this.props.rows}
                        name={this.props.nome}                                                    
                        id={this.props.id}     
                        value={this.props.value}                        
                        //defaultValue={this.props.defaultValue} 
                        className={"form-control " + this.classNameInput()}
                        disabled={this.props.disabled} 
                        maxLength={this.props.maxLength}                           

                        onChange={input => this.onChange(input)}                            
                        onKeyPress={input => this.onKeyPress(input)}
                        onBlur={e => this.onBlur(e)}
                        readOnly={this.props.readOnly} 
                    />

                    <span className="help-block">
                        {this.erro()}
                    </span>
                </div>
            </Col>
        )
    }

    render() {
        return (
            <Fragment>
                {this.show()}
            </Fragment>  
        )
    }
}

InputMemo.defaultProps = {
    md: 12,    
    defaultFoco: false,
    visible: true,
    readOnly: false,
    tooltip: '',
    rows: 10,    
};

export default InputMemo;